import React, {Component} from 'react';

import {observer} from 'mobx-react';
import {KeyboardArrowUp} from "../../../core/icons/keyboard-arrow/keyboard-arrow-up";
import {KeyboardArrowDown} from "../../../core/icons/keyboard-arrow/keyboard-arrow-down";
import {LANGUAGE_MENU} from "../language-menu-module.consts";
import classNames from "classnames";
import styles from "../styles/language-menu.module.scss";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export const LanguageMenuModuleArrow = observer(({controller}) => {
  const {state, terms} = controller;
  const {isMenuOpen, menuModel} = state;
  const {shouldRenderButtonLabel} = menuModel;
  const {WEB_LANG_MENU_MORE_BUTTON, WEB_LANG_MENU_LESS_BUTTON} = terms;
  const arrowButtonClassName: String = isMenuOpen ? styles.open_arrow_button : styles.closed_arrow_button;

  const buttonProps = {
    className: classNames(styles.collapsed_button, arrowButtonClassName),
    onClick: (e) => {
      e.stopPropagation();
      e.preventDefault();

      controller.action(LANGUAGE_MENU.ACTION_TYPES.onMenuClick)
    }
  }

  const arrowColor = useThemeColor(COLORS.textPrimary)
  const arrowProps = {
    color: arrowColor,
    style: {
      fill: arrowColor
    }
  };

  const label: String = isMenuOpen ? WEB_LANG_MENU_LESS_BUTTON : WEB_LANG_MENU_MORE_BUTTON;
  const ArrowComponent: Component = isMenuOpen ? <KeyboardArrowUp {...arrowProps}/> : <KeyboardArrowDown  {...arrowProps}/>

  return (
    <div {...buttonProps}>
      {shouldRenderButtonLabel ? label : null}
      {ArrowComponent}
    </div>
  )
});
